import OSS from 'ali-oss'

// OSS配置
const OSS_CONFIG = {
  region: 'oss-cn-guangzhou', // OSS服务的区域
  bucket: 'hf-ime', // OSS bucket名称
  domain: 'https://hf-ime.oss-cn-guangzhou.aliyuncs.com', // OSS域名
  // 为了安全，建议使用STS临时凭证或者后端签名方式
  // 这里提供两种方式的配置
}

// 方式1: 使用固定的AccessKey（不推荐用于生产环境）
const createOSSClientWithAccessKey = () => {
  return new OSS({
    region: OSS_CONFIG.region,
    accessKeyId: 'LTAI5tLYzptQ8WZWzFCsDUbs',
    accessKeySecret: '1VoLTLYhJRSEFnPuQYKJSrZSweUHlN',
    bucket: OSS_CONFIG.bucket
  })
}

// 方式2: 使用STS临时凭证（推荐）
// eslint-disable-next-line no-unused-vars
const createOSSClientWithSTS = async () => {
  try {
    // 从后端获取STS临时凭证
    const { createApiUrl, createRequestOptions, API_CONFIG } = await import('./api')
    const response = await fetch(
      createApiUrl(API_CONFIG.endpoints.oss.stsToken),
      createRequestOptions({ method: 'GET' })
    )
    
    if (!response.ok) {
      throw new Error('获取STS凭证失败')
    }
    
    const stsData = await response.json()
    
    return new OSS({
      region: OSS_CONFIG.region,
      accessKeyId: stsData.AccessKeyId,
      accessKeySecret: stsData.AccessKeySecret,
      stsToken: stsData.SecurityToken,
      bucket: OSS_CONFIG.bucket
    })
  } catch (error) {
    console.error('创建OSS客户端失败:', error)
    throw error
  }
}

// 上传文件到OSS
export const uploadToOSS = async (file, path = 'announcements') => {
  try {
    // 使用STS方式创建客户端（推荐）
    // const client = await createOSSClientWithSTS()
    
    // 如果STS不可用，回退到AccessKey方式
    const client = createOSSClientWithAccessKey()
    
    // 生成文件名
    const timestamp = Date.now()
    const fileExtension = file.name.split('.').pop()
    const fileName = `${path}/${timestamp}_${Math.random().toString(36).substr(2, 9)}.${fileExtension}`
    
    // 上传文件
    await client.put(fileName, file)
    
    // 构建自定义域名URL
    const fileUrl = `${OSS_CONFIG.domain}/${fileName}`
    
    return {
      success: true,
      url: fileUrl,
      name: fileName
    }
  } catch (error) {
    console.error('OSS上传失败:', error)
    return {
      success: false,
      error: error.message
    }
  }
}

// 删除OSS文件
export const deleteFromOSS = async (fileName) => {
  try {
    const client = createOSSClientWithAccessKey()
    await client.delete(fileName)
    return { success: true }
  } catch (error) {
    console.error('OSS删除失败:', error)
    return { success: false, error: error.message }
  }
}

export default {
  uploadToOSS,
  deleteFromOSS
} 